import Vue from 'vue';
import routes from "./router";

require('./bootstrap');
import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';
import 'jquery-datetimepicker/build/jquery.datetimepicker.full';
import {
    BootstrapVue
} from "bootstrap-vue";
import vClickOutside from "v-click-outside";
import VueMask from "v-mask";
import Vuelidate from "vuelidate";
import VueApexCharts from "vue-apexcharts";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSweetalert2 from "vue-sweetalert2";
import axios from 'axios';
import FlashMessage from '@smartweb/vue-flash-message';
import 'vue-search-select/dist/VueSearchSelect.css'
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.use(require('vue-moment'));
Vue.use(BootstrapVue);
Vue.use(vClickOutside);
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
        libraries: "places",
    },
    installComponents: true,
});

Vue.use(FlashMessage);
Vue.component("apexchart", VueApexCharts);

const app = new Vue({
    el: '#app',
    router: routes
});
